module.exports = __webpack_public_path__ + "images/Flag.9501626b5ce00c2d96b8adf1477257d0.svg";